import {
  POST_GRAFANA_ENABLE_DISABLE_ALERTS,
  POST_GRAFANA_ENABLE_DISABLE_ALERTS_FAIL,
  POST_GRAFANA_ENABLE_DISABLE_ALERTS_SUCCESS,
  POST_GRAFANA_CREATE_RESOURCE_ALERTS,
  POST_GRAFANA_CREATE_RESOURCE_ALERTS_FAIL,
  POST_GRAFANA_CREATE_RESOURCE_ALERTS_SUCCESS,
  POST_GRAFANA_CREATE_DYNAMIC_ALERT,
  POST_GRAFANA_CREATE_DYNAMIC_ALERT_FAIL,
  POST_GRAFANA_CREATE_DYNAMIC_ALERT_SUCCESS,
  GET_GRAFANA_ALERTS,
  GET_GRAFANA_ALERTS_FAIL,
  GET_GRAFANA_ALERTS_SUCCESS,
  GET_GRAFANA_DYNAMIC_ALERTS,
  GET_GRAFANA_DYNAMIC_ALERTS_FAIL,
  GET_GRAFANA_DYNAMIC_ALERTS_SUCCESS,
  GET_GRAFANA_MISSING_DYNAMIC_ALERTS,
  GET_GRAFANA_MISSING_DYNAMIC_ALERTS_FAIL,
  GET_GRAFANA_MISSING_DYNAMIC_ALERTS_SUCCESS,
  GET_GRAFANA_DEFAULT_THRESHOLD,
  GET_GRAFANA_DEFAULT_THRESHOLD_FAIL,
  GET_GRAFANA_DEFAULT_THRESHOLD_SUCCESS,
  GET_GRAFANA_RESOURCE_BY_ID,
  GET_GRAFANA_RESOURCE_BY_ID_FAIL,
  GET_GRAFANA_RESOURCE_BY_ID_SUCCESS,
  GET_GRAFANA_RESOURCE_DEFAULT_THRESHOLD_BY_ID,
  GET_GRAFANA_RESOURCE_DEFAULT_THRESHOLD_BY_ID_FAIL,
  GET_GRAFANA_RESOURCE_DEFAULT_THRESHOLD_BY_ID_SUCCESS,
  POST_GRAFANA_ALERT,
  POST_GRAFANA_ALERT_FAIL,
  POST_GRAFANA_ALERT_SUCCESS,
  GET_GRAFANA_RESCAN,
  GET_GRAFANA_RESCAN_FAIL,
  GET_GRAFANA_RESCAN_SUCCESS,
  GET_GRAFANA_MISSING_ALERT_BY_RESOURCE_ID,
  GET_GRAFANA_MISSING_ALERT_BY_RESOURCE_ID_FAIL,
  GET_GRAFANA_MISSING_ALERT_BY_RESOURCE_ID_SUCCESS,
  GET_GRAFANA_ALL_RESOURCE_ALERTS_PAGE,
  GET_GRAFANA_ALL_RESOURCE_ALERTS_PAGE_FAIL,
  GET_GRAFANA_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
  GET_GRAFANA_ALL_RESOURCE_ALERTS_COUNT_PAGE,
  GET_GRAFANA_ALL_RESOURCE_ALERTS_COUNT_PAGE_FAIL,
  GET_GRAFANA_ALL_RESOURCE_ALERTS_COUNT_PAGE_SUCCESS,
  POST_GRAFANA_SERVICE_MAPPING,
  POST_GRAFANA_SERVICE_MAPPING_FAIL,
  POST_GRAFANA_SERVICE_MAPPING_SUCCESS,
  POST_GRAFANA_RESOURCE_OPSGENIE_TEAM_MAPPING,
  POST_GRAFANA_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
  POST_GRAFANA_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
  POST_GRAFANA_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
  POST_GRAFANA_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL,
  POST_GRAFANA_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS,
  GET_GRAFANA_RESOURCES,
  GET_GRAFANA_RESOURCES_FAIL,
  GET_GRAFANA_RESOURCES_SUCCESS,
  GET_ALL_ORG_GRAFANA_RESOURCE_TYPES,
  GET_ALL_ORG_GRAFANA_RESOURCE_TYPES_FAIL,
  GET_ALL_ORG_GRAFANA_RESOURCE_TYPES_SUCCESS,
  GET_RESCAN_STATUS_GRAFANA,
  GET_RESCAN_STATUS_GRAFANA_FAIL,
  GET_RESCAN_STATUS_GRAFANA_SUCCESS,
  POST_UPDATE_GRAFANA_THRESHOLD,
  POST_UPDATE_GRAFANA_THRESHOLD_FAIL,
  POST_UPDATE_GRAFANA_THRESHOLD_SUCCESS,
  POST_ENABLE_DISABLE_GRAFANA_THRESHOLD,
  POST_ENABLE_DISABLE_GRAFANA_THRESHOLD_FAIL,
  POST_ENABLE_DISABLE_GRAFANA_THRESHOLD_SUCCESS,
  GET_GRAFANA_MISSING_ALERTS_BY_RESOURCE_ID,
  GET_GRAFANA_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
  GET_GRAFANA_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
  GET_GRAFANA_THRESHOLD,
  GET_GRAFANA_THRESHOLD_FAIL,
  GET_GRAFANA_THRESHOLD_SUCCESS,
  GET_GRAFANA_ALL_BUSINESS_TRANSACTIONS,
  GET_GRAFANA_ALL_EXTERNAL_SERVICES,
  GET_GRAFANA_ALL_BUSINESS_TRANSACTIONS_FAIL,
  GET_GRAFANA_ALL_BUSINESS_TRANSACTIONS_SUCCESS,
  GET_GRAFANA_ALL_EXTERNAL_SERVICES_FAIL,
  GET_GRAFANA_ALL_EXTERNAL_SERVICES_SUCCESS,
  GET_GRAFANA_NON_KEY_TRANSACTIONS,
  GET_GRAFANA_NON_KEY_TRANSACTIONS_FAIL,
  GET_GRAFANA_NON_KEY_TRANSACTIONS_SUCCESS,
  POST_MARK_GRAFANA_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION,
  POST_MARK_GRAFANA_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION_FAIL,
  POST_MARK_GRAFANA_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION_SUCCESS,
} from "./actionTypes"


const INIT_STATE = {
  data: {},
  grafana_resources: [],
  grafana_rescan_status: true,
  grafana_all_resource_count:{},
  grafana_all_business_transactions:{resources_info:{},resources_count:0},
  grafana_all_external_services:{resources_info:{},resources_count:0},
  orgGrafanaResourceTypes: [],
  response: {},
  grafana_alerts:[],
  grafana_dynamic_alerts:{},
  grafana_missing_dynamic_alerts:{},
  grafana_resource_default_threshold:[],
  defaultThreshold:{},
  grafana_resource:{},
  grafana_resource_missing_alerts:{},
  is_grafana_threshold_refreshing: false,
  GrafanaThreshold: [],
  non_key_transactions:[],
  post_mark_non_key_transaction_as_business_transaction_response:{}
}

const Grafana = (state = INIT_STATE, action) => {
  switch (action.type) {

    case GET_GRAFANA_THRESHOLD:
      return{
        ...state,
        error: action.payload
      }

    case GET_GRAFANA_THRESHOLD_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case GET_GRAFANA_THRESHOLD_SUCCESS:
      return{
        ...state,
        GrafanaThreshold: action.payload
      }

    case GET_RESCAN_STATUS_GRAFANA:
      return{
        ...state,
        error: action.payload,
      }

    case GET_RESCAN_STATUS_GRAFANA_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case GET_RESCAN_STATUS_GRAFANA_SUCCESS:
      return{
        ...state,
        grafana_rescan_status:  action.payload.scan_completed
      }

    case GET_ALL_ORG_GRAFANA_RESOURCE_TYPES:
      return{
        ...state,
        error: action.payload
      }

    case GET_ALL_ORG_GRAFANA_RESOURCE_TYPES_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case GET_ALL_ORG_GRAFANA_RESOURCE_TYPES_SUCCESS:
      return{
        ...state,
        orgGrafanaResourceTypes: action.payload
      }

    case GET_GRAFANA_RESOURCES:
      return{
        ...state,
        error: action.payload
      }

    case GET_GRAFANA_RESOURCES_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case GET_GRAFANA_RESOURCES_SUCCESS:
      return{
        ...state,
        grafana_resources: action.payload
      }

    case GET_GRAFANA_RESCAN:
      return{
        ...state,
        error: action.payload,
        grafana_rescan_status:false
      }

    case GET_GRAFANA_RESCAN_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case GET_GRAFANA_RESCAN_SUCCESS:
      return{
        ...state,
        data: action.payload
      }

    case GET_GRAFANA_MISSING_ALERT_BY_RESOURCE_ID:
      return{
        ...state,
        error: action.payload
      }

    case GET_GRAFANA_MISSING_ALERT_BY_RESOURCE_ID_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case GET_GRAFANA_MISSING_ALERT_BY_RESOURCE_ID_SUCCESS:
      return{
        ...state,
        data: action.payload
      }

    case GET_GRAFANA_ALL_RESOURCE_ALERTS_PAGE:
      return{
        ...state,
        data: action.payload
      }

    case GET_GRAFANA_ALL_RESOURCE_ALERTS_PAGE_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case GET_GRAFANA_ALL_RESOURCE_ALERTS_PAGE_SUCCESS:
      return{
        ...state,
        grafana_all_resource_alerts: action.payload
      }

    case GET_GRAFANA_ALL_RESOURCE_ALERTS_COUNT_PAGE:
      return{
        ...state,
        error: action.payload
      }

    case GET_GRAFANA_ALL_RESOURCE_ALERTS_COUNT_PAGE_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case GET_GRAFANA_ALL_RESOURCE_ALERTS_COUNT_PAGE_SUCCESS:
      return{
        ...state,
        grafana_all_resource_count: action.payload
      }

    case POST_GRAFANA_SERVICE_MAPPING:
      return{
        ...state,
        error: action.payload
      }

    case POST_GRAFANA_SERVICE_MAPPING_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case POST_GRAFANA_SERVICE_MAPPING_SUCCESS:
      return{
        ...state,
        response: action.payload
      }

    case POST_GRAFANA_RESOURCE_OPSGENIE_TEAM_MAPPING:
      return{
        ...state,
        error: action.payload
      }  

    case POST_GRAFANA_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case POST_GRAFANA_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS:
      return{
        ...state,
        response: action.payload
      }

    case POST_GRAFANA_RESOURCE_PAGERDUTY_SERVICE_MAPPING:
      return{
        ...state,
        error: action.payload
      }

    case POST_GRAFANA_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case POST_GRAFANA_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS:
      return{
        ...state,
        response: action.payload
      }

    case POST_GRAFANA_ALERT:
      return{
        ...state,
        error: action.payload
      }
    
    case POST_GRAFANA_ALERT_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case POST_GRAFANA_ALERT_SUCCESS:
      return{
        ...state,
        response: action.payload
      }
    case POST_GRAFANA_ENABLE_DISABLE_ALERTS: 
      return{
        ...state,
        error: action.payload
      }

    case POST_GRAFANA_ENABLE_DISABLE_ALERTS_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case POST_GRAFANA_ENABLE_DISABLE_ALERTS_SUCCESS:
      return{
        ...state,
        data: action.payload
      }

    case POST_GRAFANA_CREATE_RESOURCE_ALERTS:
      return{
        ...state,
        error: action.payload
      }

    case POST_GRAFANA_CREATE_RESOURCE_ALERTS_SUCCESS:
      return{
        ...state,
        data: action.payload
      }

    case POST_GRAFANA_CREATE_RESOURCE_ALERTS_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case POST_GRAFANA_CREATE_DYNAMIC_ALERT:
      return{
        ...state,
        error: action.payload
      }

    case POST_GRAFANA_CREATE_DYNAMIC_ALERT_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case POST_GRAFANA_CREATE_DYNAMIC_ALERT_SUCCESS:
      return{
        ...state,
        data: action.payload
      }

    case GET_GRAFANA_ALERTS:
      return{
        ...state,
        error: action.payload
      }

    case GET_GRAFANA_ALERTS_SUCCESS:
      return{
        ...state,
        grafana_alerts: action.payload
      }

    case GET_GRAFANA_ALERTS_FAIL:
      return{
        ...state,
        error: action.payload
      }
      
    case GET_GRAFANA_DYNAMIC_ALERTS:
      return{
        ...state,
        error: action.payload
      }

    case GET_GRAFANA_DYNAMIC_ALERTS_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case GET_GRAFANA_DYNAMIC_ALERTS_SUCCESS:
      return{
        ...state,
        grafana_dynamic_alerts: action.payload
      }

    case GET_GRAFANA_MISSING_DYNAMIC_ALERTS:
      return{
        ...state,
        error: action.payload
      }

    case GET_GRAFANA_MISSING_DYNAMIC_ALERTS_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case GET_GRAFANA_MISSING_DYNAMIC_ALERTS_SUCCESS:
      return{
        ...state,
        grafana_missing_dynamic_alerts: action.payload
      }

    case GET_GRAFANA_DEFAULT_THRESHOLD:
      return{
        ...state,
        error: action.payload
      }

    case GET_GRAFANA_DEFAULT_THRESHOLD_SUCCESS:
      return{
        ...state,
        defaultThreshold: action.payload
      }

    case GET_GRAFANA_DEFAULT_THRESHOLD_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case GET_GRAFANA_RESOURCE_BY_ID:
      return{
        ...state,
        error: action.payload
      }

    case GET_GRAFANA_RESOURCE_BY_ID_SUCCESS:
      return{
        ...state,
        grafana_resource: action.payload
      }

    case GET_GRAFANA_RESOURCE_BY_ID_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case GET_GRAFANA_RESOURCE_DEFAULT_THRESHOLD_BY_ID:
      return{
        ...state,
        error: action.payload
      }

    case GET_GRAFANA_RESOURCE_DEFAULT_THRESHOLD_BY_ID_SUCCESS:
      return{
        ...state,
        grafana_resource_default_threshold: action.payload
      }

    case GET_GRAFANA_RESOURCE_DEFAULT_THRESHOLD_BY_ID_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case POST_UPDATE_GRAFANA_THRESHOLD:
      return{
        ...state,
        error: action.payload,
        is_grafana_threshold_refreshing: true,
      }

    case POST_UPDATE_GRAFANA_THRESHOLD_FAIL:
      return{
        ...state,
        error: action.payload,
        is_grafana_threshold_refreshing: false,
      }

    case POST_UPDATE_GRAFANA_THRESHOLD_SUCCESS:
      return{
        ...state,
        response: action.payload,
        is_grafana_threshold_refreshing: false,
      }

    case POST_ENABLE_DISABLE_GRAFANA_THRESHOLD:
      return{
        ...state,
        error: action.payload
      }

    case POST_ENABLE_DISABLE_GRAFANA_THRESHOLD_FAIL:
      return{
        ...state,
        error: action.payload
      }

    case POST_ENABLE_DISABLE_GRAFANA_THRESHOLD_SUCCESS:
      return{
        ...state,
        response: action.payload
      }

    case GET_GRAFANA_MISSING_ALERTS_BY_RESOURCE_ID:
      return {
        ...state,
        error: action.payload,
      }

    case GET_GRAFANA_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS:
      return {
        ...state,
        grafana_resource_missing_alerts: action.payload
      }

    case GET_GRAFANA_MISSING_ALERTS_BY_RESOURCE_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      }

  case GET_GRAFANA_ALL_BUSINESS_TRANSACTIONS:
    return {
        ...state,
        error: action.payload,
    }
  case GET_GRAFANA_ALL_BUSINESS_TRANSACTIONS_FAIL:
    return {
        ...state,
        error: action.payload,
    }
    case GET_GRAFANA_ALL_BUSINESS_TRANSACTIONS_SUCCESS:
        return {
            ...state,
            grafana_all_business_transactions: action.payload,
        }

    case GET_GRAFANA_ALL_EXTERNAL_SERVICES:
        return {
            ...state,
            error: action.payload,
        }
    case GET_GRAFANA_ALL_EXTERNAL_SERVICES_FAIL:
        return {
            ...state,
            error: action.payload,
        }
    case GET_GRAFANA_ALL_EXTERNAL_SERVICES_SUCCESS:
        return {
            ...state,
            grafana_all_external_services: action.payload,
        }

    case GET_GRAFANA_NON_KEY_TRANSACTIONS:
        return {
            ...state,
            error: action.payload,
        }
    case GET_GRAFANA_NON_KEY_TRANSACTIONS_FAIL:
        return {
            ...state,
            error: action.payload,
        }
    case GET_GRAFANA_NON_KEY_TRANSACTIONS_SUCCESS:
        return {
            ...state,
            non_key_transactions: action.payload,
        }
    case POST_MARK_GRAFANA_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION:
        return {
            ...state,
            error: action.payload,
        }
    case POST_MARK_GRAFANA_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION_FAIL:
        return {
            ...state,
            error: action.payload,
        }
    case POST_MARK_GRAFANA_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION_SUCCESS:
        return {
            ...state,
            post_mark_non_key_transaction_as_business_transaction_response: action.payload,
        }
    default:
      return state;

  }
}

export default Grafana;